import { allAnchors } from '@/mocks/home';
import SmartLink from '@/components/feature/SmartLink';

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50 pt-16 md:pt-24 pb-8">
      <div className="wrap">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 border-b border-background-50/20 pb-10">
          <p className="max-w-sm text-[15px] leading-[1.6] text-background-50/75">Independent advice on strategy, transformation and leadership alignment.</p>
          <nav className="flex flex-wrap gap-x-7 gap-y-3">
            {allAnchors.map((l) => (
              <SmartLink key={l.href} href={l.href} className="label-xs text-background-50/75 hover:text-background-50 link-line pb-1 cursor-pointer whitespace-nowrap">{l.label}</SmartLink>
            ))}
          </nav>
        </div>
        <p className="font-heading font-extralight uppercase text-[22vw] md:text-[18vw] leading-[0.85] tracking-[0.04em] mt-10 select-none">Auren</p>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-8 border-t border-background-50/20 pt-5">
          <span className="label-xs text-background-50/60">&copy; 2026 AUREN Management Consulting</span>
          <a href="#top" aria-label="Back to top" onClick={(e) => { e.preventDefault(); window.scrollTo(0, 0); }} className="circle-arrow inv-light text-background-50 cursor-pointer"><i className="ri-arrow-up-line" /></a>
        </div>
      </div>
    </footer>
  );
}